// 한국어
import koKR from 'antd/lib/locale/ko_KR';
// 중국어 번체 (대만)
import zhTW from 'antd/lib/locale/zh_TW';
// 일본어
import jaJP from 'antd/lib/locale/ja_JP';
// 영어
import enUS from 'antd/lib/locale/en_US';

export const localeMap = {
  ko: koKR,
  cn: zhTW,
  jp: jaJP,
  en: enUS,
};
